import { TranslateLoader } from '@ngx-translate/core';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class WebpackTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    /**
     * 注意：src/app/core/services/ 到 src/assets/i18n/ 需要向上跳三级 ../../../
     */
    return from(import(`../../../assets/i18n/${lang}.json`)).pipe(
      map((m: any) => m.default || m)
    );
  }
}
